import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Empty, Loading, PageHead, useAdmin } from "./ui";

const toDate = (s) => new Date(`${s}T12:00:00`);
const addDays = (s, n) => { const d = toDate(s); d.setDate(d.getDate() + n); return d.toLocaleDateString("en-CA"); };
const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Nassau" });
const monday = (s) => addDays(s, -((toDate(s).getDay() + 6) % 7));
const DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export default function MyCalendar() {
  const [start, setStart] = useState(() => monday(today()));
  const end = addDays(start, 6);
  const { data } = useAdmin(`my-calendar?${start}`, `/admin/my-calendar?start=${start}&end=${end}`);
  const days = Array.from({ length: 7 }, (_, i) => addDays(start, i));
  return (
    <div data-testid="admin-my-calendar">
      <PageHead eyebrow={data?.member?.name || "Schedule"} title="My calendar">
        <button className="ad-icon-btn" onClick={() => setStart(addDays(start, -7))} aria-label="Previous week" data-testid="my-cal-prev"><ChevronLeft size={16} /></button>
        <button className="btn light" onClick={() => setStart(monday(today()))} data-testid="my-cal-today">This week</button>
        <button className="ad-icon-btn" onClick={() => setStart(addDays(start, 7))} aria-label="Next week" data-testid="my-cal-next"><ChevronRight size={16} /></button>
      </PageHead>
      {!data ? <Loading /> : !data.member ? <Empty>Your login isn't linked to a team member yet. Please ask the spa owner.</Empty> : (
        <div className="mc-week" data-testid="my-cal-week">
          {days.map((d, i) => {
            const items = data.bookings.filter((b) => b.date === d);
            const h = data.member.hours?.[DAY_KEYS[i]];
            const off = data.member.days_off?.find((o) => o.start <= d && d <= (o.end || o.start));
            return (
              <div className={`ad-card mc-day ${d === today() ? "is-today" : ""}`} key={d} data-testid={`my-cal-day-${d}`}>
                <div className="mc-head">
                  <strong>{toDate(d).toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })}</strong>
                  <small className="muted-sm">{off ? `Off${off.note ? ` · ${off.note}` : ""}` : h?.on ? `${h.start}–${h.end}` : "Day off"}</small>
                </div>
                {items.length === 0 ? <small className="muted-sm">No appointments</small> : items.map((b) => (
                  <div className="mc-item" key={b.id} style={{ borderLeftColor: data.member.color }} data-testid={`my-cal-booking-${b.id}`}>
                    <strong>{b.time_label}</strong>
                    <span>{b.treatment.split(" — ").pop()}{b.duration && ` · ${b.duration}`}</span>
                    <span className={`pill ${b.status === "confirmed" ? "st-pill-confirmed" : "st-pill-tentative"}`}>{b.status}</span>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
